import { ApolloError, gql, useQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { QueryOptionsType } from 'basics/types/common.types';
import { CustomerEngagementPlanning, SortFilter } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_ALL_CEP = gql`
query GetCustomerEngagementPlanningsQuery($limit: Int!, $offset: Int!, $filters: CepFilter, $useAdminFilters: Boolean, $sort: SortFilter) {
  getCustomerEngagementPlannings(limit: $limit, offset: $offset, filters: $filters, useAdminFilters: $useAdminFilters, sort: $sort) {
    customerEngagementPlannings {
      _id
      title,
      cepId,
      formattedCepId,
      status,
      customerInitiative {
        _id
      },
      dateStart,
      updated,
      published,
      createdAt,
      veevaSyncStatus
      popularity
      globalCepSyncStatus {
        syncStatus,
        errors
      }
    }
    count
  }
}
`;

type ResultType = {
  getCustomerEngagementPlannings: {
    customerEngagementPlannings: CustomerEngagementPlanning[];
    count: number;
  };
};

type UseGetCeps = (filters?: unknown, queryOptions?: QueryOptionsType, useAdminFilters?: boolean, sort?: SortFilter,) => {
  loading: boolean;
  error?: ApolloError;
  data: CustomerEngagementPlanning[];
  count: number;
};

const useGetAllCepQuery: UseGetCeps = (
  filters?: unknown,
  queryOptions = { limit: 5000, offset: 0 },
  useAdminFilters?: boolean,
  sort?: SortFilter,
) => {
  const { limit, offset } = queryOptions;

  const { data, loading, error } = useQuery<ResultType>(GET_ALL_CEP, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
    variables: {
      limit,
      offset,
      filters,
      useAdminFilters,
      sort,
    },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'getAllCustomerEngagementPlannings.ts - useGetAllCustomerEngagementPlanningQuery',
    });
  }

  return {
    data: data?.getCustomerEngagementPlannings.customerEngagementPlannings || [],
    count: data?.getCustomerEngagementPlannings.count || 0,
    loading,
    error,
  };
};

export default useGetAllCepQuery;
